//checkApp 为全局的 app 对象，checkApp.core 包括了核心 api 
const { Feature, meta, event } = checkApp.core;//eslint-disable-line

//通过继承 Featrue 实现一个扩展
//meta 用于描述插件的名称、依赖及权重
@meta('viewState', [], 99999)
export default class ViewStateFeature extends Feature {

  @event('checkBox.check')
  onCheck() {
    const { keyword, selectedSuffix } = this.getState();
    console.log(keyword, selectedSuffix);
    location.hash = `#/?keyword=${keyword}&suffix=${selectedSuffix}`;
  }

}


// WEBPACK FOOTER //
// ./src/view-state/index.js